import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetClassSessionsAttendanceAnalyticsAPIResponse {
  data: Data;
}

interface Data {
  classSessions: Array<ClassSession>;
  pagination: Pagination;
}

export interface ClassSession {
  date: string;
  startTime: string;
  endTime: string;
  room: string;
  instructor: string;
  status: 'Completed' | 'Upcoming';
}

export interface Pagination {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetClassSessionsAttendanceAnalyticsParams {
  enrollmentId: string;
  limit?: number;
  page?: number;
}

export const getClassSessionsAttendanceAnalytics = async ({
  enrollmentId,
  page = 1,
  limit = 10,
}: GetClassSessionsAttendanceAnalyticsParams) => {
  const response =
    await baseAPI.get<GetClassSessionsAttendanceAnalyticsAPIResponse>(
      `/students/attendance/sessions/${enrollmentId}`,
      {
        params: {
          page,
          limit,
        },
      },
    );
  return response.data;
};

export const getClassSessionsAttendanceAnalyticsOptions = (
  params: GetClassSessionsAttendanceAnalyticsParams,
) =>
  queryOptions({
    queryKey: [KEYS.CLASS_SESSIONS, params],
    queryFn: () => getClassSessionsAttendanceAnalytics(params),
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });

export const useGetClassSessionsAttendanceAnalytics = (
  params: GetClassSessionsAttendanceAnalyticsParams,
) => {
  return useQuery(getClassSessionsAttendanceAnalyticsOptions(params));
};
